<ng-container *transloco="let t; prefix: 'manage-payment-accounts'">
  <!-- Create Payment Account modal -->
  <qwiko-modal
    [id]="'manage-payment-accounts'"
    [isFullScreen]="true"
    [isCentered]="true"
    [isDismissible]="true"
    (closeEvent)="closeModal('close')"
  >
    @if (isListAccounts()) {
      <div
        class="z-50 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
      >
        <div
          class="sticky-nav flex md:hidden justify-start items-center mb-2 w-full"
        >
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="closeModal('close')"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </button>
        </div>
        <div
          class="sticky-nav hidden md:flex justify-end items-center mb-2 w-full"
        >
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="closeModal('close')"
          >
            <span class="flex items-center gap-1">
              <span class="text-sm font-light mt-[0.1rem]" *transloco="let t">{{
                t("close")
              }}</span>
              <i class="fa-light text-base fa-xmark"></i>
            </span>
          </button>
        </div>
        <div class="w-full px-4 py-2 mx-auto">
          <h2 class="text-2xl font-normal text-left md:text-center w-full mb-2">
            {{ t("your_accounts") }}
          </h2>
          <p class="text-left md:text-center w-full mb-2">
            {{ t("your_accounts_caption") }}
          </p>
        </div>
      </div>

      <div class="w-full md:w-9/12 mx-auto pb-10 px-6 md:px-5 pt-2">
        @for (
          account of businessPaymentAccounts();
          track $index;
          let count = $count
        ) {
          @if (loading()) {
            <div
              class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 text-neutral-400 text-center my-2"
            >
              <span class="loading loading-spinner w-9"></span>
            </div>
          } @else {
            <button
              type="button"
              [disabled]="loading()"
              (click)="editAccount(account)"
              class="btn flex flex-row justify-between items-center p-3 w-full text-md border-neutral-200 mt-2 rounded-box border shadow text-md text-base-content font-normal bg-base-200 h-auto hover:md:bg-base-100 dark:bg-base-100 dark:border-[0.5px] dark:border-base-300 dark:hover:md:bg-primary dark:hover:md:text-white"
            >
              <div class="flex flex-row gap-3 justify-center items-center">
                <div class="rounded-full size-11 bg-neutral-400">
                  <img
                    src="/assets/icons/providers/{{
                      account.payment_provider?.icon
                    }}"
                    class=""
                    alt=""
                  />
                </div>
                <div class="flex flex-col items-start">
                  <span class="text-lg">{{
                    account.label ? account.label : account.name
                  }}</span>
                  <span class="">{{ account.number_display }}</span>
                </div>
              </div>
              <i
                class="fa-light fa-pen-to-square text-neutral-500 text-xl mr-1"
              ></i>
            </button>
          }
        } @empty {
          @if (loading()) {
            <div
              class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 text-neutral-400 text-center my-2"
            >
              <span class="loading loading-spinner w-9"></span>
            </div>
          } @else {
            <div
              class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 border-dashed border border-neutral-400 text-neutral-400 text-center my-2"
            >
              <i class="fa-light fa-xmark-to-slot text-lg"></i>
              <p class="text-md mt-1">{{ t("no_payment_accounts") }}</p>
            </div>
          }
        }
      </div>
      <div
        class="sticky-footer card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
      >
        <button
          type="button"
          class="btn btn-md w-full md:w-9/12 mx-auto rounded-box"
          ngClass="{{
            businessPaymentAccounts().length
              ? 'btn-outline btn-ghost'
              : 'btn-primary'
          }}
        "
          (click)="addPaymentAccount()"
        >
          <span class="flex items-center gap-3">
            <i class="fa-light fa-circle-plus text-2xl"></i>
            <span class="text-base mt-1">{{ t("add_payment_method") }}</span>
          </span>
        </button>
      </div>
    }

    @if (isSelectProvider()) {
      <div
        class="sticky-nav md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
      >
        <div class="flex md:hidden justify-start items-center mb-2 w-full">
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="closeModal('close')"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </button>
        </div>
        <div class="hidden md:flex justify-end items-center mb-2 w-full">
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="closeModal('close')"
          >
            <span class="flex items-center gap-1">
              <span class="text-sm font-light mt-[0.1rem]" *transloco="let t">{{
                t("close")
              }}</span>
              <i class="fa-light text-base fa-xmark"></i>
            </span>
          </button>
        </div>
        <div class="w-full px-4 py-2 mx-auto">
          <h2 class="text-2xl font-normal text-left md:text-center w-full mb-2">
            {{ t("choose_provider") }}
          </h2>
          <p class="text-left md:text-center w-full mb-2">
            {{ t("choose_provider_caption") }}
          </p>
          <label
            class="input border border-neutral-400 focus-within:!outline-none flex items-center gap-2 rounded-full w-full md:w-8/12 mx-auto"
          >
            <i
              class="fa-solid fa-magnifying-glass text-lg text-neutral-400"
            ></i>
            <input
              id="paymentProviderFilter"
              type="text"
              class="grow text-lg"
              [(ngModel)]="paymentProviderFilter"
              placeholder="Search"
              name="paymentProviderFilter"
            />
          </label>
        </div>
      </div>

      <div class="w-full md:w-8/12 mx-auto max-h-[80vh] px-6 md:px-5 mt-2 mb-6">
        @for (
          provider of paymentProviders() | textSearch: paymentProviderFilter();
          track $index;
          let count = $count
        ) {
          @if (loading()) {
            <div
              class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 text-neutral-400 text-center my-2"
            >
              <span class="loading loading-spinner w-9"></span>
            </div>
          } @else {
            <button
              type="button"
              [disabled]="loading()"
              (click)="selectProvider(provider)"
              class="btn flex flex-row justify-between items-center py-2 px-3 w-full text-md text-base-content font-normal bg-base-200 h-auto md:hover:bg-base-100 first:mt-3 last:mb-3 first:rounded-t-box last:rounded-b-box only:rounded-box rounded-none border-[0.7px] border-base-100 dark:bg-base-100 dark:border-[0.5px] dark:border-base-300 dark:md:hover:bg-primary dark:md:hover:text-white"
              [ngClass]="
                selectedProvider()?.code == provider.code
                  ? '!bg-primary md:hover:!bg-primary !text-white'
                  : ''
              "
            >
              <div
                class="flex flex-row gap-3 justify-center items-center text-lg"
              >
                <div class="rounded-full size-10 bg-neutral-400">
                  <img
                    src="/assets/icons/providers/{{ provider.icon }}"
                    class=""
                    alt=""
                  />
                </div>
                <span class="mt-1">{{ provider.display_name }}</span>
              </div>
              <i
                class="fa-solid fa-chevron-right text-lg mr-1 text-base-content"
              ></i>
            </button>
          }
        } @empty {
          @if (!loading()) {
            <div
              class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 border-dashed border border-neutral-400 text-neutral-400 text-center my-2"
            >
              <i class="fa-light fa-xmark-to-slot text-lg"></i>
              <p class="text-md mt-1">{{ t("no_providers") }}</p>
            </div>
          } @else {
            <div
              class="flex items-center justify-center gap-2 rounded-xl px-4 py-2 text-neutral-400 text-center my-2"
            >
              <span class="loading loading-spinner w-9"></span>
            </div>
          }
        }
      </div>
    }

    @if (isAddAccount()) {
      <div
        class="z-50 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
      >
        <div
          class="sticky-nav right-0 left-0 flex justify-start items-center mb-2 w-full"
        >
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="back()"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </button>
        </div>
        <div class="w-full px-4 py-2 mx-auto">
          <img
            class="rounded-full size-20 mx-auto mb-4"
            src="/assets/icons/providers/{{ selectedProvider()?.icon }}"
            alt=""
          />
          <h2 class="text-2xl font-normal text-center w-full mb-2">
            {{ t("add_title") }}
          </h2>
          <h2 class="text-xl font-normal text-center w-full mb-2">
            {{ selectedProvider()?.display_name }}
          </h2>
        </div>
      </div>

      <div class="w-full md:w-8/12 mx-auto px-6 md:px-5 mt-2 mb-6">
        <form #addMethodForm="ngForm" class="w-full">
          <!-- @if (alert()) {
               <qwiko-alert [(alert)]="alert"></qwiko-alert>
             } -->
          <div class="w-full flex flex-col gap-y-2 items-center">
            <label class="form-control w-full">
              <div class="label">
                <span class="label-text flex gap-1">
                  <span>
                    {{ t("account_name") }}
                  </span>
                  <span
                    class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
                  ></span>
                </span>
              </div>
              <input
                #account_name="ngModel"
                [(ngModel)]="accountName"
                type="text"
                name="account_name"
                [placeholder]="t('account_name_placeholder')"
                class="input input-bordered input-md text-lg w-full rounded-box"
                [ngClass]="
                  account_name.invalid && account_name.touched
                    ? 'input-error text-error'
                    : ''
                "
                required
                [disabled]="loading()"
              />
              <div
                [ngClass]="
                  account_name.invalid && account_name.touched ? '' : 'hidden'
                "
                class="label"
              >
                <span class="label-text-alt text-error">{{
                  t("account_name_error")
                }}</span>
              </div>
            </label>

            <label class="form-control w-full">
              <div class="label">
                @if (
                  selectedProvider()?.account_type?.code == accountTypeCode.MOMO
                ) {
                  <span class="label-text flex gap-1">
                    <span>
                      {{ t("account_number") }}
                    </span>
                    <span
                      class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
                    ></span>
                  </span>
                } @else {
                  <span class="label-text flex gap-1">
                    <span>
                      {{ t("account_code") }}
                    </span>
                    <span
                      class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
                    ></span>
                  </span>
                }
              </div>

              <label
                class="bg-base-100 flex font-semibold gap-0 h-full input items-center text-xl text-base-content py-2 rounded-box w-full input-bordered"
              >
                @if (
                  selectedProvider()?.account_type?.code == accountTypeCode.MOMO
                ) {
                  <span class="text-xl flex items-center gap-2">
                    <span class="mt-1">{{ country().phone_code }}</span>
                  </span>
                }
                <input
                  type="text"
                  class="grow mt-1"
                  (paste)="formatOnPaste($event)"
                  (keyup)="formatPhoneNumber()"
                  #account_number="ngModel"
                  [(ngModel)]="accountNumber"
                  [placeholder]="
                    selectedProvider()?.account_type?.code ==
                    accountTypeCode.MOMO
                      ? t('account_number_placeholder')
                      : t('account_code_placeholder')
                  "
                  name="accountNumber"
                  inputmode="numeric"
                  type="tel"
                  pattern="\d*"
                  required
                  [disabled]="loading()"
                />
              </label>

              <div
                [ngClass]="
                  account_number.invalid && account_number.touched
                    ? ''
                    : 'hidden'
                "
                class="label"
              >
                @if (
                  selectedProvider()?.account_type?.code == accountTypeCode.MOMO
                ) {
                  <span class="label-text-alt text-error">{{
                    t("account_number_error")
                  }}</span>
                } @else {
                  <span class="label-text-alt text-error">{{
                    t("account_code_error")
                  }}</span>
                }
              </div>
            </label>

            <label class="form-control w-full">
              <div class="label">
                <span class="label-text">{{ t("account_label") }} </span>
              </div>
              <input
                #account_label="ngModel"
                [(ngModel)]="accountLabel"
                type="text"
                name="accountLabel"
                [placeholder]="t('account_label_placeholder')"
                class="input input-bordered input-md text-lg w-full rounded-box"
                [ngClass]="
                  account_label.invalid && account_label.touched
                    ? 'input-error text-error'
                    : ''
                "
                [disabled]="loading()"
                maxlength="18"
              />
              <div class="label">
                <span class="label-text-alt text-neutral-400">{{
                  t("account_label_caption")
                }}</span>
              </div>
            </label>
          </div>
        </form>
      </div>

      <div
        class="sticky-footer card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
      >
        <button
          [disabled]="addMethodForm.invalid || loading()"
          type="button"
          class="btn btn-md w-full md:w-8/12 mx-auto btn-primary rounded-box"
          (click)="saveAccount()"
        >
          @if (loading()) {
            <span class="loading loading-spinner"></span>
          } @else {
            <span> {{ t("save_account") }} </span>
          }
        </button>
      </div>
    }

    @if (isEditAccount()) {
      <div
        class="z-50 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
      >
        @if (isDirectEdit()) {
          <div
            class="sticky-nav flex md:hidden justify-start items-center mb-2 w-full"
          >
            <button
              type="button"
              class="btn btn-sm btn-ghost rounded-full"
              (click)="closeModal('close')"
            >
              <span class="flex items-center gap-1">
                <i class="fa-light text-xl fa-arrow-left"></i>
                <span class="text-base mt-1" *transloco="let t">{{
                  t("back")
                }}</span>
              </span>
            </button>
          </div>
          <div
            class="sticky-nav hidden md:flex justify-end items-center mb-2 w-full"
          >
            <button
              type="button"
              class="btn btn-sm btn-ghost rounded-full"
              (click)="closeModal('close')"
            >
              <span class="flex items-center gap-1">
                <span
                  class="text-sm font-light mt-[0.1rem]"
                  *transloco="let t"
                  >{{ t("close") }}</span
                >
                <i class="fa-light text-base fa-xmark"></i>
              </span>
            </button>
          </div>
        } @else {
          <div class="sticky-nav flex justify-start items-center mb-2 w-full">
            <button
              type="button"
              class="btn btn-sm btn-ghost rounded-full"
              (click)="back()"
            >
              <span class="flex items-center gap-1">
                <i class="fa-light text-xl fa-arrow-left"></i>
                <span class="text-base mt-1" *transloco="let t">{{
                  t("back")
                }}</span>
              </span>
            </button>
          </div>
        }

        <div class="w-full px-4 py-2 mx-auto">
          <img
            class="rounded-full size-20 mx-auto mb-4"
            src="/assets/icons/providers/{{
              selectedAccount()?.payment_provider?.icon
            }}"
            alt=""
          />
          <h2 class="text-2xl font-normal text-center w-full mb-2">
            {{ t("edit_title") }}
          </h2>
        </div>
      </div>

      <div class="w-full md:w-8/12 mx-auto px-6 md:px-5 mt-2 mb-6">
        <form #editAccountForm="ngForm" class="w-full">
          <!-- @if (alert()) {
                 <qwiko-alert [(alert)]="alert"></qwiko-alert>
               } -->
          <div class="w-full flex flex-col gap-y-2 items-center">
            <label class="form-control w-full">
              <div class="label">
                <span class="label-text flex gap-1">
                  <span>
                    {{ t("name") }}
                  </span>
                  <span
                    class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
                  ></span>
                </span>
              </div>
              <input
                #account_name="ngModel"
                [(ngModel)]="accountName"
                type="text"
                name="account_name"
                [placeholder]="t('account_name_placeholder')"
                class="input input-bordered input-md text-lg w-full rounded-box"
                [ngClass]="
                  account_name.invalid && account_name.touched
                    ? 'input-error text-error'
                    : ''
                "
                required
                [disabled]="loading()"
              />
              <div
                [ngClass]="
                  account_name.invalid && account_name.touched ? '' : 'hidden'
                "
                class="label"
              >
                <span class="label-text-alt text-error">{{
                  t("account_name_error")
                }}</span>
              </div>
            </label>

            <label class="form-control w-full">
              <div class="label">
                @if (selectedAccount()?.type?.code == accountTypeCode.MOMO) {
                  <span class="label-text flex gap-1">
                    <span>
                      {{ t("account_number") }}
                    </span>
                    <span
                      class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
                    ></span>
                  </span>
                } @else {
                  <span class="label-text flex gap-1">
                    <span>
                      {{ t("account_code") }}
                    </span>
                    <span
                      class="badge badge-error self-start mt-1 size-[0.4rem] p-0"
                    ></span>
                  </span>
                }
              </div>

              <label
                class="bg-base-100 flex font-semibold gap-0 h-full input items-center text-xl text-base-content py-2 rounded-box w-full input-bordered"
              >
                @if (selectedAccount()?.type?.code == accountTypeCode.MOMO) {
                  <span class="text-xl flex items-center gap-2">
                    <span class="mt-1">{{ country().phone_code }}</span>
                  </span>
                }
                <input
                  type="text"
                  class="grow mt-1"
                  (paste)="formatOnPaste($event)"
                  (keyup)="formatPhoneNumber()"
                  #account_number="ngModel"
                  [(ngModel)]="accountNumber"
                  [placeholder]="
                    selectedAccount()?.type?.code == accountTypeCode.MOMO
                      ? t('account_number_placeholder')
                      : t('account_code_placeholder')
                  "
                  name="accountNumber"
                  inputmode="numeric"
                  type="tel"
                  pattern="\d*"
                  required
                  [disabled]="loading()"
                />
              </label>

              <div
                [ngClass]="
                  account_number.invalid && account_number.touched
                    ? ''
                    : 'hidden'
                "
                class="label"
              >
                @if (selectedAccount()?.type?.code == accountTypeCode.MOMO) {
                  <span class="label-text-alt text-error">{{
                    t("account_number_error")
                  }}</span>
                } @else {
                  <span class="label-text-alt text-error">{{
                    t("account_code_error")
                  }}</span>
                }
              </div>
            </label>

            <label class="form-control w-full">
              <div class="label">
                <span class="label-text">{{ t("account_label") }} </span>
              </div>
              <input
                #account_label="ngModel"
                [(ngModel)]="accountLabel"
                type="text"
                name="accountLabel"
                [placeholder]="t('account_label_placeholder')"
                class="input input-bordered input-md text-lg w-full rounded-box"
                [ngClass]="
                  account_label.invalid && account_label.touched
                    ? 'input-error text-error'
                    : ''
                "
                [disabled]="loading()"
                maxlength="18"
              />
              <div class="label">
                <span class="label-text-alt text-neutral-400">{{
                  t("account_label_caption")
                }}</span>
              </div>
            </label>
          </div>
        </form>
      </div>

      <div
        class="sticky-footer md:mt-10 card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
      >
        <button
          [disabled]="editAccountForm.invalid || loading()"
          type="button"
          class="btn btn-md w-full md:w-8/12 mx-auto btn-primary rounded-box"
          (click)="updateAccount()"
        >
          @if (loading()) {
            <span class="loading loading-spinner"></span>
          } @else {
            <span> {{ t("edit_account") }}</span>
          }
        </button>
        @if (businessPaymentAccounts().length > 1) {
          <button
            [disabled]="loading()"
            type="button"
            class="btn btn-sm w-full md:w-8/12 mx-auto btn-link text-error opacity-65 hover:opacity-100 rounded-box"
            (click)="softDeleteAccount()"
          >
            @if (loading()) {
              <span class="loading loading-spinner"></span>
            } @else {
              <span> {{ t("delete_account") }}</span>
            }
          </button>
        }
      </div>
    }

    @if (isDeleteAccount()) {
      <div
        class="z-50 pt-2 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
      >
        <div class="sticky-nav justify-start items-center mb-2 w-full hidden">
          <button
            type="button"
            class="btn btn-sm btn-ghost rounded-full"
            (click)="back()"
          >
            <span class="flex items-center gap-1">
              <i class="fa-light text-xl fa-arrow-left"></i>
              <span class="text-base mt-1" *transloco="let t">{{
                t("back")
              }}</span>
            </span>
          </button>
        </div>
        <div class="w-full px-4 py-2 mx-auto">
          <img
            class="rounded-full size-20 mx-auto mb-4"
            src="/assets/icons/providers/{{
              selectedAccount()?.payment_provider?.icon
            }}"
            alt=""
          />
          <h2 class="text-2xl font-normal text-center w-full mb-2">
            {{ t("delete_title") }}
          </h2>
        </div>
      </div>

      <div class="w-full md:w-8/12 mx-auto px-6 md:px-5 mt-2 mb-6">
        <button
          type="button"
          [disabled]="loading()"
          class="btn flex flex-row justify-between items-center p-3 w-full text-md border-neutral-200 mt-2 rounded-box border shadow text-md text-base-content font-normal bg-base-200 h-full hover:bg-base-100 dark:bg-base-100 dark:border-[0.5px] dark:border-base-300 dark:hover:bg-primary dark:hover:text-white"
        >
          <div class="flex flex-row gap-3 justify-center items-center">
            <div class="rounded-full size-11 bg-neutral-400">
              <img
                src="/assets/icons/providers/{{
                  selectedAccount()?.payment_provider?.icon
                }}"
                class=""
                alt=""
              />
            </div>
            <div class="flex flex-col items-start">
              <span class="text-lg">{{
                selectedAccount()?.label
                  ? selectedAccount()?.label
                  : selectedAccount()?.name
              }}</span>
              <span class="">{{ selectedAccount()?.number }}</span>
            </div>
          </div>
          <!-- <i class="fa-solid fa-trash text-xl mr-1"></i> -->
        </button>
      </div>

      <div
        class="sticky-footer md:mt-10 card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
      >
        <button
          [disabled]="loading()"
          type="button"
          class="btn btn-md btn-outline w-full md:w-8/12 mx-auto text-base-content dark:text-white opacity-65 hover:opacity-100 rounded-box"
          (click)="editAccount()"
        >
          @if (loading()) {
            <span class="loading loading-spinner"></span>
          } @else {
            <span> {{ t("no_edit_instead") }}</span>
          }
        </button>
        <button
          [disabled]="loading()"
          type="button"
          class="btn btn-md btn-outline w-full md:w-8/12 mx-auto btn-error rounded-box"
          (click)="softDeleteAccount()"
        >
          @if (loading()) {
            <span class="loading loading-spinner"></span>
          } @else {
            <span> {{ t("yes_delete_account") }}</span>
          }
        </button>
      </div>
    }
  </qwiko-modal>
</ng-container>
